import React, { useMemo, useState } from 'react';
import CardView from '../../components/Redesing/card-view';
import { Button, MenuItem, Stack } from '@mui/material';
import PageContainer from '../../components/Redesing/page-container';
import {
  MovaticFieldGroupSelect,
  MovaticFieldGroupText,
} from '../../components/Redesing/movatic-field-group';
import AddIcon from '@mui/icons-material/Add';
import useAllHardwareProduct from '../../hooks/hardwareProduct/query/useAllHardwareProduct';
import CustomAsyncToast from '../../components/Redesing/custom-async-toast';
import { useAddHardwareVersion } from '../../hooks/hardwareProduct/query/use-add-hardware-version';

function AddVersion() {
  const [formState, setFormState] = useState({
    product: '',
    name: '',
    description: '',
  });

  const {
    data: hardwareProduct,
    isLoading: hardwareProductLoading,
    refetch: refetchHardwareProduct,
  } = useAllHardwareProduct();

  const { mutateAsync: addHardwareVersion } = useAddHardwareVersion();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormState((prev: any) => ({ ...prev, [name]: value }));
  };

  const productOptions = useMemo(() => {
    return hardwareProduct?.map((product: any) => ({
      name: product.name,
      value: product.name,
    }));
  }, [hardwareProduct]);

  const handleSave = () => {
    const version = {
      name: formState.name,
      description: formState.description,
      hardware_product_id: formState.product,
    };

    CustomAsyncToast({
      promise: () => addHardwareVersion(version),
      successMessage: () => 'Version added successfully',
      loadingMessage: () => `Adding version...`,
      errorMessage: () => `Error adding version`,
    }).then((response) => {
      if (response) {
        setFormState({
          name: '',
          description: '',
          product: '',
        });
        refetchHardwareProduct();
      }
    });
  };

  const content = () => {
    return (
      <Stack px={2} pb={2}>
        <MovaticFieldGroupSelect
          name="product"
          optionNodes={productOptions.map((item: any) => (
            <MenuItem key={item.value} value={item.value}>
              {item.name}
            </MenuItem>
          ))}
          label="Hardware Product"
          description="Select the hardware product that this version belongs to"
          value={formState.product}
          onChange={handleChange}
          data-id="hardware-product-product"
        />

        <MovaticFieldGroupText
          name="name"
          label="Name"
          description="Version number of the product (eg v1, 1.2, etc)"
          value={formState.name}
          onChange={handleChange}
          data-id="hardware-product-name"
        />

        <MovaticFieldGroupText
          name="description"
          label="Description"
          description="Description of this version of the product"
          value={formState.description}
          onChange={handleChange}
          data-id="hardware-product-description"
        />
      </Stack>
    );
  };

  return (
    <PageContainer isLoading={hardwareProductLoading}>
      <CardView
        title={'Add Hardware Product'}
        content={content()}
        headerActions={
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleSave}
            data-id="add-hardware-product-button"
          >
            Add
          </Button>
        }
        isLoading={false}
        data-id={'add-hardware-product-version-button'}
      />
    </PageContainer>
  );
}

export default AddVersion;
